import { Rule } from "antd/es/form";
import { useMemo } from "react";
import { PERCENT_LIMIT } from "../constants";

export const usePercentageRule = () => {
  const percentageRules: Rule[] = useMemo(
    () => [
      { required: true },
      {
        type: "number",
        transform: (value: any) => +value,
        max: 100,
        message: PERCENT_LIMIT,
        validateTrigger: "onSubmit",
      },
    ],
    [],
  );

  return { percentageRules };
};
